export { default } from './TermsDialog';



// WEBPACK FOOTER //
// ./src/components/molecules/TermsDialog/index.js